export default "__VITE_ASSET__BZ5VW4Uu__"